module.exports = __webpack_public_path__ + "img/title_picture.77d27f52.png";